// extracted by mini-css-extract-plugin
export default {"sidenav":"Sidebar_sidenav__Vtwgj","sidenav-container":"Sidebar_sidenav-container__kVGys","fullspace":"Sidebar_fullspace__TeqlA","wrapper":"Sidebar_wrapper__JRAQE"};